import { render, staticRenderFns } from "./AllGames.vue?vue&type=template&id=9c39304c&lang=pug&"
import script from "./AllGames.vue?vue&type=script&lang=js&"
export * from "./AllGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielrubiocastillo/Documents/workspaces/emaraplay/lobby-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c39304c')) {
      api.createRecord('9c39304c', component.options)
    } else {
      api.reload('9c39304c', component.options)
    }
    module.hot.accept("./AllGames.vue?vue&type=template&id=9c39304c&lang=pug&", function () {
      api.rerender('9c39304c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AllGames.vue"
export default component.exports